'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SrcSource = function SrcSource(props) {
  var _this = this;

  _classCallCheck(this, SrcSource);

  _defineProperty(this, "props", null);

  _defineProperty(this, "isCompatible", function () {
    return !!_this.props.src;
  });

  _defineProperty(this, "get", function (setState) {
    setState({
      sourceName: 'src',
      src: _this.props.src
    });
  });

  this.props = props;
};

exports.default = SrcSource;

_defineProperty(SrcSource, "propTypes", {
  src: _propTypes.default.string
});


//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/lib/sources/Src.js
// module id = 2192
// module chunks = 0